import { ButtonClass, DialogSize, launchDialog } from "@pjs/core-ui";
import { userUiI18n } from "../../i18n/UserUiI18n.const";
import { temporaryAccessActions } from "../../actions/TemporaryAccessActions.const";

export const launchConfirmRevokeDialog = (
    tempAccessId: string,
    isTempAccessSession: boolean,
    cachedTrigger: HTMLElement,
    clearIsRevoking: () => void
): void => {
    const cancelLabel = userUiI18n.getString("temporary_access.revoke_access.dialog.cancel_button");
    const revokeLabel = userUiI18n.getString("temporary_access.revoke_access.dialog.revoke_button");

    launchDialog<{ htmlContent: string }>({
        component: () => import("@pjs/core-ui").then((module) => module.SimpleHtmlDialogContent),
        title: userUiI18n.getString("temporary_access.revoke_access.dialog.title"),
        size: DialogSize.Small,
        initialModel: {
            htmlContent: userUiI18n.getString("temporary_access.revoke_access.dialog.description")
        },
        dismissAction: (_model, instance) => {
            clearIsRevoking();
            instance.close(() => {
                if (cachedTrigger !== null && document.body.contains(cachedTrigger)) {
                    cachedTrigger.focus();
                }
            });
        },
        actions: [
            {
                label: cancelLabel,
                ariaLabel: cancelLabel,
                buttonClass: ButtonClass.Outlined,
                dataHook: "revoke-temp-access-cancel-button",
                disabled: () => false,
                action: (_model, instance) => {
                    clearIsRevoking();
                    instance.close(() => {
                        if (cachedTrigger !== null && document.body.contains(cachedTrigger)) {
                            cachedTrigger.focus();
                        }
                    });
                }
            },
            {
                label: revokeLabel,
                ariaLabel: revokeLabel,
                buttonClass: ButtonClass.Contained,
                dataHook: "revoke-temp-access-confirm-button",
                disabled: () => false,
                action: (_model, instance) => {
                    instance.close(() => {
                        clearIsRevoking();
                        if (cachedTrigger !== null && document.body.contains(cachedTrigger)) {
                            cachedTrigger.focus();
                        }
                        temporaryAccessActions.revokeTemporaryAccess(tempAccessId, isTempAccessSession);
                    });
                }
            }
        ]
    });
};
